import find from 'lodash/find'
import { FieldOption } from './accountTypes'

const options: FieldOption[] = [
  { value: 'ACTIVE', name: 'Active' },
  { value: 'TRANSFERRED', name: 'Transferred' },
  { value: 'OPTED_OUT', name: 'Opted Out' },
  { value: 'INCOMPLETE_INTAKE', name: 'Incomplete Intake' },
  { value: 'REFUNDED', name: 'Refunded' },
  { name: 'Canceled', value: 'CANCELED' }
]

export function statusName (value: string): string | null {
  const option = find(options, { value })
  return option ? option.name : null
}

export default options
